import createCache from 'src/internal/revamp/apollo/createCache';
import {getApolloSharedCaches} from 'src/internal/shared/apollo/getApolloSharedCaches';

import type {InMemoryCache} from '@apollo/client';
import type {SchemaConfig} from 'src/internal/revamp/config/types';

export function getCache(
  schemas: ReadonlyArray<SchemaConfig>,
  sharedCache?: InMemoryCache,
  sharedCacheId?: symbol,
) {
  if (sharedCache && sharedCacheId) {
    throw new Error('Cannot specify both sharedCache and sharedCacheId');
  }

  if (sharedCache) {
    return sharedCache;
  }

  const sharedApolloCaches = getApolloSharedCaches();

  if (sharedCacheId) {
    const existingCache = sharedApolloCaches.get(sharedCacheId);

    if (existingCache) {
      return existingCache;
    }
  }

  const cache = createCache(schemas);

  if (sharedCacheId) {
    sharedApolloCaches.set(sharedCacheId, cache);
  }

  return cache;
}
